import { Close } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { handleRemove, selectGstRegister } from "redux/reducers/gstRegisterSlice";
import { getTitle } from "utils";
import { StyledAppliedFilterItem } from "views/tasks/Filters/styles";

function AppliedFilters() {
  const { appliedFilters } = useSelector(selectGstRegister);
  const dispatch = useDispatch();

  const onRemoveFilter = (filter: string) => {
    dispatch(
      handleRemove({
        key: filter
      })
    );
  };

  return (
    <Box display="flex" gap={2} mx={2} px={1.6} pb={1.1}>
      {Object.keys(appliedFilters).map((filter, filterIndex: number) => {
        const value = appliedFilters[filter];
        // Multi-select filters (e.g. status) store an array of {label,value}
        // objects instead of a single one - handle both shapes uniformly.
        const isArrayFilter = Array.isArray(value);
        const hasValue = isArrayFilter ? value.length > 0 : !!value?.value;
        if (!hasValue) return null;
        const label = isArrayFilter
          ? value.map((v: any) => v?.label).filter(Boolean).join(", ")
          : value?.label;
        return (
          <Box display="flex" gap={1} alignItems="center" key={filterIndex}>
            <Typography variant="caption">{getTitle(filter)}:</Typography>
            <Box display="flex" gap="4px" alignItems="center">
              <StyledAppliedFilterItem
                onClick={() => {
                  onRemoveFilter(filter);
                }}
              >
                <Typography variant="body2">
                  {label}
                </Typography>
                <Close sx={{ fontSize: "11px" }} />
              </StyledAppliedFilterItem>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default AppliedFilters;
